import React from "react";
import { Modal } from "antd";

import CommonButton from "../Components/Buttons/CommonButton";
import classes from "./Modal.module.css";

function Failureanalysismodal({
  data,
  onCancel,
  heading,
  open,
  closable,
}: {
  data: any;
  onCancel: () => void;
  heading: any;
  open: boolean;
  closable: boolean;
}) {
  return (
    <>
      <Modal
        open={open}
        closable={closable}
        className={classes.FailureAnalysisModalWidth}
        footer={null}
      >
        <div className={classes.modal_container}>
          <h4 className={classes.modal_heading}>{heading}</h4>

          <p>{data}</p>

          <div className={classes.modal_button_container}>
            <CommonButton
              name="Close"
              type="button"
              onClick={() => {
                onCancel();
              }}
              classname="cancel_btn"
            />
          </div>
        </div>
      </Modal>
    </>
  );
}
export default Failureanalysismodal;
